__turbopack_context__.v({
  "modal": "asset-store-module__lELeZW__modal",
  "pagination": "asset-store-module__lELeZW__pagination",
  "paginationWrapper": "asset-store-module__lELeZW__paginationWrapper",
  "search": "asset-store-module__lELeZW__search",
  "searchWrapper": "asset-store-module__lELeZW__searchWrapper",
  "shopCartWrapper": "asset-store-module__lELeZW__shopCartWrapper",
  "titleModal": "asset-store-module__lELeZW__titleModal",
  "titleModalText": "asset-store-module__lELeZW__titleModalText",
});
